// Progressive enhancement for the newsletter forms (form[data-newsletter-form]), which post to
// our Mimeo (https://link.skyteargames.com/subscribe): intercepts the submit so visitors stay
// on-page and see an inline message. Without JS the form posts to the Mimeo's own "check your
// email" page. Double opt-in either way: the Mimeo emails a confirmation link, and nobody is
// added until it's clicked. Loaded (defer) by both the footer and the newsletter section,
// possibly twice on one page — the guard keeps a single delegated listener.
(function () {
  if (window.__newsletterFormsBound) return;
  window.__newsletterFormsBound = true;

  // After a signup the form gives way to an unmissable "action required" notice naming the
  // address, so nobody leaves thinking they're done before clicking the confirmation link.
  // Styled by .newsletter-notice in sections/footer.liquid (the footer is on every page).
  function confirmNotice(form) {
    var input = form.querySelector('input[type="email"]');
    var notice = document.createElement('div');
    notice.className = 'newsletter-notice';
    notice.setAttribute('role', 'status');
    notice.tabIndex = -1;

    var eyebrow = document.createElement('p');
    eyebrow.className = 'newsletter-notice__eyebrow';
    eyebrow.textContent = 'Action required';
    var text = document.createElement('p');
    text.className = 'newsletter-notice__text';
    var address = document.createElement('strong');
    address.textContent = input ? input.value.trim() : 'your inbox';
    text.append('Check ', address, ' and click the link to confirm your subscription.');
    var retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'newsletter-notice__retry';
    retry.textContent = 'Use a different address';
    retry.addEventListener('click', function () {
      notice.remove();
      form.hidden = false;
      form.reset();
      if (input) input.focus();
    });

    notice.append(eyebrow, text, retry);
    form.hidden = true;
    form.after(notice);
    notice.focus();
  }

  var FAILURE = 'Something went wrong — please check the address and try again.';
  var NOT_READY = 'Just a moment — checking you’re not a bot. Please try again in a second.';

  // Cloudflare Turnstile (snippets/newsletter-turnstile.liquid): load its script once, only on
  // pages whose forms carry the widget. Its token is single-use, so the widget resets after
  // every submit.
  if (document.querySelector('.cf-turnstile') && !document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]')) {
    var turnstileScript = document.createElement('script');
    turnstileScript.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    turnstileScript.async = true;
    turnstileScript.defer = true;
    document.head.appendChild(turnstileScript);
  }
  function resetTurnstile(form) {
    var widget = form.querySelector('.cf-turnstile');
    if (widget && window.turnstile) window.turnstile.reset(widget);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-newsletter-form]');
    if (!form) return;
    event.preventDefault();

    var msg = form.querySelector('[data-newsletter-msg]');
    var errorClass = form.dataset.newsletterErrorClass;
    var button = form.querySelector('button[type="submit"]');
    var show = function (text, isError) {
      if (!msg) return;
      msg.hidden = false;
      msg.textContent = text;
      if (errorClass) msg.classList.toggle(errorClass, isError);
    };

    var widget = form.querySelector('.cf-turnstile');
    var token = form.querySelector('[name="cf-turnstile-response"]');
    if (widget && (!token || !token.value)) return show(NOT_READY, true);

    if (button) button.disabled = true;
    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var failed = data.status === 'failed' || (data.errors && data.errors.length);
        if (failed) return show(FAILURE, true);
        confirmNotice(form);
      })
      .catch(function () {
        show(FAILURE, true);
      })
      .finally(function () {
        if (button) button.disabled = false;
        resetTurnstile(form);
      });
  });
})();
